﻿import React from 'react';

import { getEpiData } from '../../../Utils/epiHelpers';

//state
import { connect } from 'react-redux';
import { fetchPossessionsData, fetchMetaData } from '../State/actions';

// components
import BasicInsuranceCoverListItem from './BasicInsuranceCoverListItem';


const BasicInsuranceCoverList = (props) => {

    const heading = getEpiData('heading', props.mountRootId) || '';
    const preamble = getEpiData('preamble', props.mountRootId) || '';

    const [expanded, setExpanded] = React.useState(false);


    React.useEffect(() => {
        props.loadPossessions();
    }, []);

    React.useEffect(() => {
        props.loadMetaData();
    }, []);

    let basicCoverage = props.possessionsData.missingBasicCoverInsurances;
    let metaData = props.metaData;
    let combined;

    if (basicCoverage && basicCoverage.length > 0) {       
        combined = basicCoverage.map(item => ({
           ...item,
           metaData: metaData.meta.filter(f => f.groupName === item.groupName)
      }));
    }


    return (
        <>
            {combined &&
                <div className="block-spacing">
                    <div className="section-spacing">
                        <h3>{heading}</h3>
                        <p>{preamble}</p>
                    </div>
                </div>
            } 

            <ul>
                {combined && combined.length > 0 && combined.map((data, ind) => (
                    <BasicInsuranceCoverListItem 
                        key={ind}
                        id={ind}
                        combined={data}
                        ind={ind}
                        expanded={expanded}
                        setExpanded={setExpanded}
                    />
                    ))
                }   
            </ul>    
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        possessionsData: state.possessionsData,
        metaData: state.metaData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadPossessions: (possessionsData) => dispatch(fetchPossessionsData(possessionsData)),
        loadMetaData: (metaData) => dispatch(fetchMetaData(metaData))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BasicInsuranceCoverList);